import component from './PhNumberCircleOne.vue_vue_type_script_lang.vue.js';
export { default } from './PhNumberCircleOne.vue_vue_type_script_lang.vue.js';
import { render } from './PhNumberCircleOne.vue_vue_type_template_id_6b091e14_lang.vue.js';

component.render = render;
